import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { Lock } from "lucide-react";
import { LANDING } from "@/constants/testIds";

export default function SiteNav() {
  const navigate = useNavigate();
  return (
    <header className="border-b border-slate-200 bg-white/95 backdrop-blur sticky top-0 z-30">
      <div className="max-w-6xl mx-auto px-5 h-16 flex items-center justify-between">
        <Link to="/" data-testid={LANDING.navHome} className="flex items-center gap-2">
          <div className="w-8 h-8 rounded-md bg-slate-900 grid place-items-center text-white font-bold font-head">M</div>
          <span className="font-head font-bold text-lg tracking-tight">MSI Scale</span>
        </Link>
        <nav className="flex items-center gap-6">
          <Link to="/pricing" data-testid={LANDING.navPricing} className="text-sm text-slate-600 hover:text-slate-900 transition-colors">Pricing</Link>
          <Link to="/sample-report" className="hidden sm:inline text-sm text-slate-600 hover:text-slate-900 transition-colors">Sample Report</Link>
          <Link to="/institutions" className="hidden sm:inline text-sm text-slate-600 hover:text-slate-900 transition-colors">For Institutions</Link>
          <Link to="/take-test" data-testid={LANDING.navTakeTest} className="text-sm text-slate-600 hover:text-slate-900 transition-colors">Take the Test</Link>
          <button data-testid={LANDING.admin} onClick={() => navigate("/admin/login")}
            className="text-sm text-slate-500 hover:text-slate-900 flex items-center gap-1 transition-colors">
            <Lock className="w-3.5 h-3.5" /> Admin
          </button>
        </nav>
      </div>
    </header>
  );
}
